import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { PRODUCTS, BUSINESS } from "@/data/site";

export const Products = () => {
  return (
    <section
      id="productes"
      data-testid="products-section"
      className="scroll-target py-24 md:py-32 bg-[#FAF5F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#C8A24A]">
            Els nostres productes
          </span>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold text-[#8B0000] mt-4">
            Dolços fets cada dia
          </h2>
          <p className="mt-5 text-[#5C4A3D] text-lg leading-relaxed">
            Una mostra del que trobaràs a la botiga. Per encàrrecs especials o
            més informació, contacta amb nosaltres.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 auto-rows-[230px] gap-5">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.id}
              data-testid={`product-card-${p.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className={`group relative overflow-hidden rounded-2xl cursor-pointer shadow-sm ${p.span}`}
            >
              <img
                src={p.img}
                alt={p.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6">
                <h3 className="font-display text-2xl font-semibold text-[#FDFBF7]">
                  {p.title}
                </h3>
                <p className="text-[#FDFBF7]/80 text-sm mt-1">{p.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            data-testid="products-whatsapp-btn"
            href={BUSINESS.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[#8B0000] text-[#FDFBF7] px-8 py-4 font-semibold hover:-translate-y-1 hover:shadow-xl transition-all"
          >
            <MessageCircle size={18} />
            Contacta per a més informació o encàrrecs
          </a>
        </div>
      </div>
    </section>
  );
};
